import { NgModule } from '@angular/core';
import { ClickOutsideDirective } from './click-outside.directive';
import * as ɵngcc0 from '@angular/core';
var ClickOutsideModule = (function () {
    function ClickOutsideModule() {
    }
ClickOutsideModule.ɵfac = function ClickOutsideModule_Factory(t) { return new (t || ClickOutsideModule)(); };
ClickOutsideModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ClickOutsideModule });
ClickOutsideModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ClickOutsideModule, [{
        type: NgModule,
        args: [{
                declarations: [ClickOutsideDirective],
                exports: [ClickOutsideDirective]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ClickOutsideModule, { declarations: function () { return [ClickOutsideDirective]; }, exports: function () { return [ClickOutsideDirective]; } }); })();
    return ClickOutsideModule;
}());
export { ClickOutsideModule };

